module.exports = __webpack_public_path__ + "img/II-43.3.674499aa.svg";